import React, { useState } from "react";
import "./ContactUs.css";
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const contactItems = [
  {
    icon: <i className="fa-solid fa-location-dot" />,
    label: "Address",
    value: "Westlands Business District, Nairobi, Kenya"
  },
  {
    icon: <i className="fa-solid fa-phone" />,
    label: "Phone",
    value: "+254 119 053 542",
    href: "tel:+254119053542"
  },
  {
    icon: <i className="fa-solid fa-envelope" />,
    label: "Email",
    value: "support@mrtruck.co.ke",
    href: "mailto:support@mrtruck.co.ke"
  },
  {
    icon: <i className="fa-brands fa-whatsapp" />,
    label: "WhatsApp",
    value: "Chat with us on WhatsApp",
    href: "https://wa.me/254119053542"
  },
];

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await addDoc(collection(db, "messages"), {
        name: form.name,
        email: form.email,
        message: form.message,
        createdAt: serverTimestamp(),
      });
      setSubmitted(true);
      setForm({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error saving message:", error);
      alert("Failed to send message. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div>
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="page-hero-label">Get in Touch</span>
        <h1>We'd Love to Hear From You</h1>
        <p>
          Have a question, a partnership idea, or need a logistics solution?
          Fill out the form and we'll get back to you promptly.
        </p>
      </div>

      {/* CONTACT BODY */}
      <div className="contact-body">

        {/* LEFT: Contact Info */}
        <div className="contact-info">
          <h3>Contact Information</h3>

          {contactItems.map((item, i) => (
            <div className="contact-info-item" key={i}>
              <div className="contact-info-icon">{item.icon}</div>
              <div className="contact-info-text">
                <strong>{item.label}</strong>
                {item.href ? (
                  <a href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">
                    {item.value}
                  </a>
                ) : (
                  <span>{item.value}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT: Form */}
        <div className="contact-form-card">
          <h3>Send Us a Message</h3>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                className="form-input"
                type="text"
                id="name"
                name="name"
                placeholder="John Kamau"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                className="form-input"
                type="email"
                id="email"
                name="email"
                placeholder="john@company.co.ke"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Your Message</label>
              <textarea
                className="form-input"
                id="message"
                name="message"
                placeholder="Tell us how we can help..."
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                style={{ resize: "vertical" }}
              />
            </div>

            <button type="submit" className="form-submit" disabled={loading}>
              {loading ? "Sending…" : "Send Message"}
            </button>
          </form>

          {submitted && (
            <div className="form-success">
              <i className="fa-solid fa-circle-check" /> Thank you! Your message has been received.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
